import * as Components from 'components/system'
import {AppearanceProvider} from '../providers/AppearanceProvider'

type Props = {
  title: string
}

export const Header = ({title}: Props) => {
  const builderManager = AppearanceProvider.useManager()

  return <Components.Header title={title} onClose={builderManager.onClose} />
}
